export default __webpack_public_path__ + "static/media/home_content_1.a6f9fc33.png";